import React from 'react';
import { Flex, MasterFilled, Text } from '@landr/maestro';
import { Trans } from '@lingui/macro';

const SamplesCount = ({ samplesCount }: { samplesCount: number }) => {
    return (
        <Flex
            alignItems="flex-start"
            color="text.medium"
            paddingTop={{ base: 'lg', md: 'xs' }}
            paddingBottom="xs"
            paddingX={{ base: 'sm', md: 0 }}
            cursor="default"
        >
            <MasterFilled size="sm" />
            <Text marginLeft="xs" textStyle="body-sm">
                <Trans>{samplesCount} / 8 samples</Trans>
            </Text>
        </Flex>
    );
};

export default SamplesCount;
